import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";
import * as inputManageAllocationAction from "../../../store/input-management-allocation/action";

import {
  IMPORT_ALLOCATE,
  GET_ALLOCATE_CONF,
  baseUrl,
} from "../../../helpers/url_api_constant";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";

import { Link, useHistory } from "react-router-dom";
import { AvField, AvForm } from "availity-reactstrap-validation";
import moment from "moment";

import React, { useEffect, useState } from "react";
import { post, postUpload } from "../../../helpers/api_helper";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import Select from "react-select";
import classnames from "classnames";
import { connect, useSelector } from "react-redux";
import paginationFactory from "react-bootstrap-table2-paginator";
import { withTranslation } from "react-i18next";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';


function AllocationData(props) {

  let history = useHistory();

  const dispatch = useDispatch();
  const location = useLocation();
  const inputAllocationListReducer = useSelector(state => state.InputManageAllocation);

  const permission = getPermission();

  const searchObj = location?.state?.goBack == true ? inputAllocationListReducer.modelSearch : { UPLOAD_DATE: "", UPLOAD_TO_DATE: "", UPLOAD_START: "", UPLOAD_TO: "", UPLOADTYPE_NAME: null, STATUS_FLAG: 0 };
  const createObj = { UPLOAD_DESC: "", };

  const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);
  const [activeTime, setActiveTime] = useState(location?.state?.goBack == true && inputAllocationListReducer.modelDeviceList.length > 0 ? inputAllocationListReducer.modelDeviceList[0] : { UPLOAD_DATE: "" });

  // const [tempSearch, setTempSearch] = useState({ UPLOAD_DATE: "", UPLOAD_TO_DATE: "", UPLOAD_START: "", UPLOAD_TO: "" });
  const [selectedFile, setSelectedFile] = useState(null);
  const [modelDeviceList, setModelDeviceList] = useState(location?.state?.goBack == true ? inputAllocationListReducer.modelDeviceList : []);

  const [activeTab, setActiveTab] = useState("1");
  const [visibleModalConfirm, setVisibleModalConfirm] = useState(false);
  const [visibleUploadAllocate, setVisibleUploadAllocate] = useState(false);
  const [visibleSelectDate, setVisibleSelectDate] = useState(false);
  const [defaultDate, setDefaultDate] = useState(new Date());
  const [ModalConfirmMesHead, setModalConfirmMesHead] = useState(
    "มีข้อมูล Allocation Data ของวันที่ dd/mm/yy อยู่ในฐานข้อมูลของ TSO Dashboard อยู่แล้ว"
  );
  const [ModalConfirmMes, setModalConfirmMes] = useState(
    "คุณต้องการลบและดึงข้อมูลจาก PMIS ใหม่หรือไม่ ?"
  );

  const [modalDelete, setModalDelete] = useState(false);

  // DropDown Search
  const [dropDownSearchType, setDropDownSearchType] = useState(location?.state?.goBack == true ? inputAllocationListReducer.dropDownSearchType : null);
  // DropDown Search

  // Handle Set Value DropDown Search //
  const handleSelectDropDownSearchType = selected => {
    setDropDownSearchType(selected);
  };
  // Handle Set Value DropDown Search //

  const listData = [
    {
      Id: "1",
      GetDataTime: "02/05/2021 03:27 PM",
      GasDay: "01/05/2021",
      FileName: "Allocation_TSO_02-05-2021.xlsx",
      Type: "Upload Excel",
      Status: "Active",
    },
    {
      Id: "2",
      GetDataTime: "02/05/2021 01:27 PM",
      GasDay: "01/05/2021",
      FileName: "Allocation_TSO_02-05-2021.xlsx",
      Type: "Upload Excel",
      Status: "-",
    },
    {
      Id: "3",
      GetDataTime: "29/04/2021 01:27 PM",
      GasDay: "28/04/2021",
      FileName: "-",
      Type: "Refresh Manual PMIS",
      Status: "-",
    },
    {
      Id: "4",
      GetDataTime: "30/04/2021 02:27 PM",
      GasDay: "29/04/2021",
      FileName: "-",
      Type: "Auto load PMIS",
      Status: "Active",
    },
  ];

  const listType = [
    { label: "Excel", value: "Excel" },
    { label: "PMIS", value: "PMIS" },
  ];

  //sort Column//
  const defaultSorted = [
    {
      dataField: "PID",
      order: "asc",
    },
  ];

  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    page: location?.state?.goBack == true ? inputAllocationListReducer.pagination.page : 1,
    sizePerPage: location?.state?.goBack == true ? inputAllocationListReducer.pagination.sizePerPage : 100,
    onSizePerPageChange: (sizePerPage, page) => {
      dispatch(inputManageAllocationAction.setPaginationToState({ sizePerPage, page }))
    },
    onPageChange: (page, sizePerPage) => {
      dispatch(inputManageAllocationAction.setPaginationToState({ sizePerPage, page }))
    },
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "750",
        value: 750,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };

  //Sort Page//

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    return (
      <div className="d-sm-flex align-items-center justify-content-center">
        <OverButton
          onClick={() => {
            gotoPageAllocationDetail(row);
          }}
          color="primary"
          icon="fas fa-eye"
          label="View"
        />
        {/* {permission.eALD && ( */}
        <OverButton
          onClick={() => {
            downloadExcel(row);
          }}
          color="success"
          icon="fas fa-file-download"
          label="Download Excel"
        />
        {/* )} */}

      </div>
    );
  };

  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }

  useEffect(function () {

    let UPLOADTYPE_NAME = dropDownSearchType != null ? dropDownSearchType.value : null;

    setSearchModel(preVent => ({
      ...preVent, UPLOADTYPE_NAME: UPLOADTYPE_NAME
    }));

    dispatch(inputManageAllocationAction.setDropDownSearchType(dropDownSearchType))

  }, [dropDownSearchType]);

  const gotoPageAllocationDetail = row => {
    history.push("/allocation-data/" + row.PID + "/allocation-data-detail");
  };
  // Action Button//

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  //format date 
  const FormatDate = (date, format) => {
    return (
      <div>
        {moment(date).format(
          format
        )}
      </div>
      // Sep-21
    );
  };
  //format date

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  //Check active
  const CheckActive = (active) => {
    // console.log(type);
    let status = "";
    let color = "";

    if (active == 1) {
      status = "Active";
      color = "success";
    } else {
      status = "-";
      color = "";
    }

    return (
      <div>
        <span className={"badge badge-soft-" + color} style={{ fontSize: 12 }}>
          {status}
        </span>
      </div>
    );
  };
  //Check active

  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      formatter: CountIndexRow,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
    },
    {
      dataField: "UPLOAD_DATE",
      text: "Get Data Time",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: true,
      isDummyField: true,
      formatter: (cellContent, row) => FormatDate(row.UPLOAD_DATE, "DD/MM/YYYY, HH:mm:ss")
    },
    {
      dataField: "UPLOAD_START",
      text: "Gas Day",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
      isDummyField: true,
      formatter: (cellContent, row) => FormatDate(row.UPLOAD_START, "DD/MM/YYYY")
    },
    {
      dataField: "UPLOAD_FILE",
      text: "File Name",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "20%",
        fontSize: "12px",
      },
      style: {
        width: "20%",
        fontSize: "12px",
      },
    },
    {
      dataField: "UPLOADTYPE_NAME",
      text: "Type",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "STATUS_FLAG",
      text: "Status",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
      isDummyField: true,
      formatter: (cellContent, row) => CheckActive(row.STATUS_FLAG)
    },
    {
      dataField: "UPLOAD_DESC",
      text: "Description",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "25%",
        fontSize: "12px",
      },
      style: {
        width: "25%",
        fontSize: "12px",
      },
    },
    {
      dataField: "df1",
      text: "Action",
      isDummyField: true,
      formatter: ButtonAction,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
        // paddingLeft: "0.7%",
        // paddingRight: "0.5%",
      },
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    if (location?.state?.goBack != true) {
      resetSearch();
    }
    resetModel();
    // setModelDeviceList(listData);
    // getMonthValue();

    ///fixed header table
    let tableId = "allocation-table";
    let scrollY = 313;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//

  //Function CURL 

  const resetSearch = () => {
    setSearchModel({ UPLOAD_DATE: "", UPLOAD_TO_DATE: "", UPLOAD_START: "", UPLOAD_TO: "", UPLOADTYPE_NAME: null, STATUS_FLAG: 0 });
    // setTempSearch({ UPLOAD_DATE: "", UPLOAD_TO_DATE: "", UPLOAD_START: "", UPLOAD_TO: "" });
    setDropDownSearchType(null);
    fetchData({ UPLOAD_DATE: "", UPLOAD_TO_DATE: "", UPLOAD_START: "", UPLOAD_TO: "", UPLOADTYPE_NAME: null, STATUS_FLAG: 0 });
  };

  const resetModel = () => {
    setCreateModel(createObj);
  };

  const onSearch = () => {
    // console.log(searchModel);
    fetchData(searchModel);
  };

  useEffect(() => {
    dispatch(inputManageAllocationAction.setModelDeviceListToState(modelDeviceList))
  }, [modelDeviceList])

  const fetchData = async (searchData) => {
    dispatch(inputManageAllocationAction.setSearchToState(searchData))
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_ALLOCATE_CONF, {
        ...searchData, UPLOAD_DATE: moment(searchData.UPLOAD_DATE).format("YYYY-MM-DD"), UPLOAD_TO_DATE: moment(searchData.UPLOAD_TO_DATE).format("YYYY-MM-DD"),
        UPLOAD_START: moment(searchData.UPLOAD_START).format("YYYY-MM-DD"), UPLOAD_TO: moment(searchData.UPLOAD_TO).format("YYYY-MM-DD"), STATUS_FLAG: searchData.STATUS_FLAG ? 1 : 0
      });
      // console.log(res);
      setModelDeviceList(res.data.allocateConfList);
      if (res.data.allocateConfList.length > 0) {
        setActiveTime(res.data.allocateConfList[0]);
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const downloadExcel = (row) => {
    dispatch(loadingAction.showLoading());
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    fetch(baseUrl + "api/DownloadFile/downloadExcelAllocateFile?ALLOCATE_PID=" + row.PID, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.ms-excel',
        'Authorization': "Bearer " + accessToken.access_token,
        'TSOSESSIONID': getUserToken(),
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          // `FileName.xlsx`,
          row.UPLOAD_FILE
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        dispatch(loadingAction.hideLoading());
      });

  };
  //Function CURL 

  const onUploadClick = () => {
    resetModel();
    setSelectedFile(null);
    setVisibleUploadAllocate(true);
  };

  const onFileChange = event => {
    setSelectedFile(event.target.files[0]);
  };

  // const validateForm = () => {
  //   // console.log(createModel);
  //   let bResult = true;

  //   if (createModel.UPLOAD_DESC == "") {
  //     bResult = false;
  //   }

  //   if (selectedFile == null) {
  //     bResult = false;
  //   }

  //   // console.log(bResult);

  //   return bResult;
  // };

  const onFileUpload = async () => {
    // if (validateForm()) {
    dispatch(loadingAction.showLoading());
    const formData = new FormData();
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    formData.append("file", selectedFile, selectedFile.name);
    formData.append('UPLOAD_DESC', createModel.UPLOAD_DESC);
    // setTimeout(async () => {
    try {
      const res = await postUpload(IMPORT_ALLOCATE, formData);
      // console.log(res);
      if (res.resultCode == 200) {
        setVisibleUploadAllocate(false);
        dispatch(messageAction.showMessage("Import success."));
        fetchData(searchModel);
      } else {
        dispatch(messageAction.showMessage("Import Error. " + res.resultDescription));
        // setVisibleModalConfirm(true);  
      }
    } catch (error) {
      // console.log(error);
      toggleModalMessage("An error occurred.");
      dispatch(messageAction.showMessage("An error occurred."));
    }
    dispatch(loadingAction.hideLoading());
    // }, 3000);
    // }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {props.t("Allocation Data")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Input Management
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Allocation Data
                        </li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card>

              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>
                      {/* <Row className="mt-3">
                        <Col sm="12">
                          <FormGroup className="row">
                            <Col sm={7}></Col>
                            <Col sm={5}>
                              <h5 className="mb-0 me-2 font-size-15 d-flex align-items-center justify-content-end">

                                เวลาที่ Active ข้อมูลล่าสุด : {activeTime.UPLOAD_DATE != "" && activeTime.UPLOAD_DATE != undefined && activeTime.UPLOAD_DATE != null ?
                                  moment(activeTime.UPLOAD_DATE).format("D/MM/YYYY, HH:mm:ss") : ""
                                }

                              </h5>{" "}
                            </Col>
                          </FormGroup>
                        </Col>
                      </Row> */}

                      {/* <Row>
                        <Col sm="12">
                          <FormGroup className="row">
                            <Col sm={6}></Col>
                            <Col sm={6}>
                              <div className="d-flex align-items-center justify-content-end">
                                {permission.eALD && (
                                  <Button
                                    onClick={() => onUploadClick(true)}
                                    color="primary"
                                    className="mt-3 w-md"
                                  >
                                    &nbsp;&nbsp;
                                    <i className="fas fa-file-upload fa-lg"></i>
                                    &nbsp; Upload Allocation Data &nbsp;&nbsp;
                                  </Button>
                                )}

                                <Button
                                  onClick={() => setVisibleSelectDate(true)}
                                  color="success"
                                  className="mt-3 ms-3 w-md"
                                  disabled
                                >
                                  <i className="fas fa-file-download fa-lg"></i>
                                  &nbsp; Load Allocation Data From PMIS
                                </Button>
                              </div>
                            </Col>
                          </FormGroup>
                        </Col>
                      </Row> */}

                      {/*                      
                      <Row className="mt-4">
                        <hr />
                      </Row> */}

                      <Row>
                        <Col sm="3">
                          <FormGroup className="row mt-2">
                            <Label className="col-sm-5 col-form-label d-flex align-items-center justify-content-end">
                              Get Data Start
                            </Label>
                            <Col sm={7}>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  altFormat: "d/m/Y",
                                  // altFormat: "F Y",
                                  dateFormat: "d/m/Y",
                                }}
                                onChange={(value) => {
                                  setSearchModel(
                                    {
                                      ...searchModel,
                                      UPLOAD_DATE: value[0]

                                    })
                                  // setTempSearch({
                                  //   ...tempSearch,
                                  //   UPLOAD_DATE: value[0]
                                  // })
                                }}
                                value={searchModel.UPLOAD_DATE}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col sm="3">
                          <FormGroup className="row mt-2">
                            <Label className="col-sm-5 col-form-label d-flex align-items-center justify-content-end">
                              Get Data End
                            </Label>
                            <Col sm={7}>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  altFormat: "d/m/Y",
                                  // altFormat: "F Y",
                                  dateFormat: "d/m/Y",
                                }}
                                onChange={(value) => {
                                  setSearchModel(
                                    {
                                      ...searchModel,
                                      UPLOAD_TO_DATE: value[0]
                                    })
                                  // setTempSearch({
                                  //   ...tempSearch,
                                  //   UPLOAD_TO_DATE: value[0]
                                  // })
                                }}
                                value={searchModel.UPLOAD_TO_DATE}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col sm="3">
                          <FormGroup className="row mt-2">
                            <Label className="col-sm-5 col-form-label d-flex align-items-center justify-content-end">
                              Type
                            </Label>
                            <Col sm={7}>
                              <Select
                                placeholder="All"
                                isClearable={true}
                                value={dropDownSearchType}
                                onChange={handleSelectDropDownSearchType}
                                options={listType}
                                classNamePrefix="select2-selection"
                                styles={SelectStyle}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col sm="3">
                          <FormGroup className="row mt-2">
                            <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                              Status
                            </Label>
                            <Col
                              sm={8}
                              className="d-flex align-items-center justify-content-start"
                            >
                              <div className="ms-3 form-check form-check-outline form-check-primary">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={searchModel.STATUS_FLAG}
                                  id="check3"
                                  onChange={e => {
                                    setSearchModel({
                                      ...searchModel,
                                      STATUS_FLAG: e.target.checked,
                                    })
                                  }}
                                />
                                <label
                                  className="form-check-label ms-2"
                                  htmlFor="check3"
                                >
                                  Active
                                </label>
                              </div>
                            </Col>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col sm="3">
                          <FormGroup className="row mt-2">
                            <Label className="col-sm-5 col-form-label d-flex align-items-center justify-content-end">
                              Start Gas Day
                            </Label>
                            <Col sm={7}>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  altFormat: "d/m/Y",
                                  // altFormat: "F Y",
                                  dateFormat: "d/m/Y",
                                }}
                                onChange={(value) => {
                                  setSearchModel(
                                    {
                                      ...searchModel,
                                      UPLOAD_START: value[0]

                                    })
                                  // setTempSearch({
                                  //   ...tempSearch,
                                  //   UPLOAD_START: value[0]
                                  // })
                                }}
                                value={searchModel.UPLOAD_START}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col sm="3">
                          <FormGroup className="row mt-2">
                            <Label className="col-sm-5 col-form-label d-flex align-items-center justify-content-end">
                              End Gas Day
                            </Label>
                            <Col sm={7}>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  altFormat: "d/m/Y",
                                  // altFormat: "F Y",
                                  dateFormat: "d/m/Y",
                                }}
                                onChange={(value) => {
                                  setSearchModel(
                                    {
                                      ...searchModel,
                                      UPLOAD_TO: value[0]

                                    })
                                  // setTempSearch({
                                  //   ...tempSearch,
                                  //   UPLOAD_TO: value[0]
                                  // })
                                }}
                                value={searchModel.UPLOAD_TO}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col sm="6">
                          <FormGroup className="row">
                            <div className="d-flex align-items-center justify-content-end">
                              <Button color="info" className="mt-3" onClick={() => onSearch()}>
                                <i className="fas fa-search"></i>
                                &nbsp; Search
                              </Button>

                              <Button color="warning" className="mt-3 ms-2" onClick={() => resetSearch()}>
                                <i className="fas fa-redo-alt"></i>
                                &nbsp; Reset
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>

                      {/* <Row>
                        <Col sm="12">
                          <FormGroup className="row">
                            <div className="d-flex align-items-center justify-content-end">
                              <Button color="info" className="mt-3" onClick={() => onSearch()}>
                                <i className="fas fa-search"></i>
                                &nbsp; Search
                              </Button>

                              <Button color="warning" className="mt-3 ms-2" onClick={() => resetSearch()}>
                                <i className="fas fa-redo-alt"></i>
                                &nbsp; Reset
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row> */}

                      <Row className="mt-3">
                        <hr />
                      </Row>

                      <Row className="align-items-center justify-content-start">
                        <Col sm="6">
                          <h5 className="font-size-15">
                            เวลาที่ Active ข้อมูลล่าสุด : {activeTime.UPLOAD_DATE != "" && activeTime.UPLOAD_DATE != undefined && activeTime.UPLOAD_DATE != null ?
                              moment(activeTime.UPLOAD_DATE).format("DD/MM/YYYY, HH:mm:ss") : ""
                            }
                          </h5>
                        </Col>

                        <Col sm="6">
                          <div className="d-flex align-items-center justify-content-end">
                            {permission.eALD && (
                              <>
                                <Button
                                  onClick={() => onUploadClick(true)}
                                  color="primary"
                                  className="w-md btn-custom-color"
                                >
                                  &nbsp;&nbsp;
                                  <i className="fas fa-file-upload fa-lg"></i>
                                  &nbsp; Upload Allocation Data &nbsp;&nbsp;
                                </Button>
                                <Button
                                  onClick={() => setVisibleSelectDate(true)}
                                  color="info"
                                  className="ms-2 w-md"
                                // disabled
                                >
                                  <i className="mdi mdi-cloud-refresh fa-lg"></i>
                                  &nbsp; Manual Refresh
                                </Button>
                              </>
                            )}
                          </div>
                        </Col>
                      </Row>

                      {/* <Row>
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                setActiveTab("1");
                              }}
                            >
                              Allocation Data
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Row> */}

                      <Row className="mt-2">
                        {/* <TabContent
                          activeTab={activeTab}
                          className="p-3 text-muted"
                        >
                          <TabPane tabId="1"> */}
                        <Col sm="12">
                          <div>

                            <BootstrapTable
                              id="allocation-table"
                              keyField="PID"
                              data={modelDeviceList}
                              columns={columns}
                              headerClasses="header-style"
                              rowStyle={rowStyleFontWhite}
                              // defaultSorted={defaultSorted}
                              pagination={paginationFactory(options)}
                            // hover
                            />
                          </div>
                        </Col>
                        {/* </TabPane>
                        </TabContent> */}
                      </Row>
                      {/* <hr /> */}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>

            {/*start : ModalUploadAllocation */}
            <Modal isOpen={visibleUploadAllocate}>
              <div className="modal-header">
                <h5 className="modal-title mt-0">Select File Upload</h5>
                <button
                  type="button"
                  onClick={() => setVisibleUploadAllocate(false)}
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <AvForm className="needs-validation">
                  <Row>
                    <Col xl="9">
                      {" "}
                      <div className="col-sm-12 mt-3">
                        <Input
                          className="form-control"
                          type="file"
                          onChange={onFileChange}
                        />
                      </div>
                    </Col>
                    <Col xl="3">
                      <div className="col-sm-12 mt-3">
                        <Button
                          color="primary"
                          type="submit"
                          onClick={() => {
                            onFileUpload();
                          }}
                          disabled={selectedFile == null}
                        >
                          <i className="fas fa-upload fa-lg"></i>
                          &nbsp; Upload
                        </Button>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-3">
                    <Label
                      className="col-sm-3 col-form-label text-center">
                      {/* <span style={{ color: "#FF0E03" }}>* </span> */}
                      Description
                    </Label>
                    <Col xl="9" className="mt-2">
                      {/* <div className="form-floating mt-3"> */}
                      <Input
                        // placeholder="Description"
                        type="textarea"
                        rows="5"
                        // name="UPLOAD_DESC"
                        // errorMessage="Enter Description"
                        className="form-control basicborder"
                        // validate={{ required: { value: true } }}
                        onChange={(e) => setCreateModel(
                          {
                            ...createModel,
                            UPLOAD_DESC: e.target.value
                          })
                        }
                        value={createModel.UPLOAD_DESC}
                      />
                      {/* <Label> Description</Label>
                      </div> */}
                    </Col>
                  </Row>
                </AvForm>
              </div>
            </Modal>
            {/*end : ModalUploadAllocation */}

            {/*start : ModalConfirm */}
            <Modal size="lg" isOpen={visibleModalConfirm}>
              <div className="modal-header">
                <h5 className="modal-title mt-0">
                  Confirm
                </h5>
                <button
                  type="button"
                  onClick={() => setVisibleModalConfirm(false)}
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <h5 className="text-center">{ModalConfirmMesHead}</h5>
                <br></br>
                <h5 className="text-center">{ModalConfirmMes}</h5>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  onClick={() => {
                    setVisibleModalConfirm(false);
                    setVisibleUploadAllocate(false);
                    setVisibleSelectDate(false);
                    // visibleModalConfirm: false,
                    // visibleUploadAllocate: false,
                    // visibleSelectDate: false,
                  }}
                  className="btn btn-success"
                >
                  <i className="fas fa-check"></i>&nbsp; Confirm
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setVisibleModalConfirm(false);
                    setVisibleUploadAllocate(false);
                  }}
                  className="btn btn-danger"
                  data-dismiss="modal"
                >
                  <i className="fas fa-times fa-lg"></i>
                  &nbsp; Cancel
                </button>
              </div>
            </Modal>
            {/*end : ModalConfirm */}

            {/*start : ModalSelectDate */}
            <Modal size="xs" isOpen={visibleSelectDate}>
              <div className="modal-header">
                <h5 className="modal-title mt-0" id="myVisibleSelectDate">
                  Select Date
                </h5>
                <button
                  type="button"
                  onClick={() => setVisibleSelectDate(false)}
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <Row>
                  <Col sm="12">
                    <FormGroup className="row mt-2">
                      {/* <Label className="col-sm-3 col-form-label d-flex align-items-center justify-content-end"> Start Date</Label> */}
                      <Col sm={12}>
                        <Flatpickr
                          // value={defaultDate}
                          className="form-control d-block"
                          placeholder="Select Date"
                          options={{
                            altInput: true,
                            altFormat: "d/m/Y",
                            // altFormat: "F Y",
                            dateFormat: "d/m/Y",
                          }}
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
              <div className="modal-footer">
              <button
                  type="button"
                  // onClick={() => {
                  //   this.togModalConfirm();
                  // }}
                  onClick={() => {
                    setVisibleModalConfirm(true);
                  }}
                  className="btn btn-success"
                >
                  <i className="bx bx-check fa-lg"></i>&nbsp;Confirm
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setVisibleSelectDate(false);
                  }}
                  className="btn btn-danger"
                  data-dismiss="modal"
                >
                  <i className="fas fa-times fa-lg"></i>
                  &nbsp; Cancel
                </button>
              </div>
            </Modal>
            {/*end : ModalSelectDate */}

            {/*start : ModalDelete */}
            <Modal
              isOpen={modalDelete}
              scrollable={true}
              backdrop={"static"}
              centered={true}
            >
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  Confirm
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setModalDelete(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p className="mt-3">Do you want to delete?</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-success">
                  <i className="fas fa-check"></i>&nbsp; Confirm
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setModalDelete(false)}
                >
                  <i className="fas fa-times"></i>
                  &nbsp; Cancel
                </button>
              </div>
            </Modal>
            {/*end : ModalDelete */}
          </Row>
        </Container>

      </div>
    </React.Fragment>
  );
}

AllocationData.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ AllocationData }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(AllocationData));

// function RenderList(prop) {
//   console.log(prop);

//   return (<tr>
//     <td>{prop.indexlist}</td>
//     <td>{prop.data.MeterPointID}</td>
//     <td>{prop.data.Customer}</td>
//     <td>{prop.data.CustomerType}</td>
//     <td>{prop.data.CommunicationType}</td>
//     <td>{prop.data.Zone}</td>
//     <td>{prop.data.Point}</td>
//     <td>{prop.data.Region}</td>
//     <td>{prop.data.Area}</td>
//     <td>{prop.data.BVZoning}</td>
//     <td>{prop.data.BV}</td>
//     <td>
//       <Button className="me-1"
//         onClick={() =>
//           setPageAdd(true)
//         }
//         color="info"
//       >
//         <i className="far fa-edit"></i>
//         &nbsp; Edit
//       </Button>
//       <Button
//         onClick={() =>
//           setModalDelete(true)
//         }
//         // className="btn-rounded"
//         color="danger"
//       >
//         <i className="fas fa-trash-alt"></i>
//         &nbsp; Delete
//       </Button>
//     </td>
//   </tr>)
// }
